import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { annotation } from './common';
import './PDQCodeHtml'

@customElement('pdq-tutorial-liquid-scripts')
class PDQTutorialLiquidScripts extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
    css`
    `];

  render() {
    const code = `
<pdq-data-request 
  id="users-table"
  url="https://jsonplaceholder.typicode.com/users"
  index="username" 
  data-type="json"
  strategy="useStale"  
  ></pdq-data-request>
  
<pdq-liquid>
  <script type="application/json" slot="variables">
{
  "users": "users-table"
}
</script>
  <script slot="liquid" type="text/liquid" >
<h1>Users:</h1>
<div class="col" id="users">
  {% if selected%}
   <p>Selected User = <strong>{{selected}}</strong></p>
  {% else %}
    <p>Please select a user from below</p>
  {% endif %}
  {% for user in users %}
  <div {% if selected == user.username %}style="background: green;"{% endif %}>
    <cds-button kind="secondary" size="sm" data-username="{{user.username}}" >Select</cds-button> {{user.name}}
  </div>
  {% endfor %}
</div>
</script>
  <script slot="script">
 // list some variables that are used in the template 
 console.log('script: this=', this)
 console.log('script: document=', document)
 console.log('script: this._variables.currentValue()=', this._variables.currentValue())
 console.log('script: this._data.currentValue()=', this._data.currentValue())
 console.log('script: this.shadowRoot=', this.shadowRoot)
 console.log('script: this.signal=', this.signal)
 
 // Add an event listener to the users div
 this.shadowRoot.querySelector('#users')?.addEventListener('click', (evt) => {
   if (evt.target.tagName !== 'CDS-BUTTON') return;
   
   this.variables = [
     ...this._variables.currentValue().filter(i => i.name != 'selected'),
     {name: 'selected', value: evt.target.dataset.username}
   ];
   
   this.dispatchEvent(new CustomEvent('selected', {
     detail: evt.target.dataset.username, 
     bubbles: true, 
     composed: true
   }));
   
 }, {signal: this.signal}) // adding signal to the event listener, prevents duplicate event listeners
 
</script>
</pdq-liquid>`;
    return html`
      <cds-tile>
        <h2>Liquid Templates: Handling Events</h2>
        <pdq-code-html code="${code}"></pdq-code-html>
        ${unsafeHTML(code)}
        
        <p>The above template renders the users from the data request, it adds a click event listener in javascript,
        it updates its own variables, which causes a re-render, and liquid changes the background color of the user</p>
        <p>Adding the singal prevents duplicate event listeners being added</p>
        <p>a 'selected' custom event is also raised (but not used) for events to escape the shadow root they must be
          set to events bubbles: true & composed: true. Alternatively don't raise the event from the element, but 
        dispatch it directly on document.</p>
        <p>Using the &lt;script type="text/liquid"&gt; tag for the content prevents issues passing advanced liquid tags</p>
      </cds-tile>
    `;
  }
}

(window as any).document.addEventListener('selected', (evt: CustomEvent) => {
  console.log('global event listener: selected', evt.detail);
})